<template>
  <div>
    <v-layout v-if="this.getStore()==23" class="hp-main-buttons mt-3 mb-5" fill-height align-start align-baseline>
      <v-flex>
        <v-layout style="flex-wrap: wrap" justify-center>
<!--      <v-flex sm12 lg12 class="text-xl-right">-->
        <v-btn style="height: auto; padding: 15px" depressed large color="button-twoline primary ex-lg-btn" @click="goToFastSelect(true)"><span class="m-icn icn-kayak"></span><span><span>Půjčovna lodí</span><span>Orlice / Labe</span></span></v-btn>
<!--      </v-flex>-->
<!--      <v-flex sm12 lg6 class="text-xl-center">-->
        <v-btn style="height: auto; padding: 15px" depressed large color="button-twoline primary ex-lg-btn" @click="selectService(getMainID())"><span class="m-icn icn-padleboard"></span><span><span>Rychlá rezervace</span><span>Paddleboard / FUN WATER PARK </br> Šlapadla / Kanoe / Koloběžky</span></span></v-btn>
<!--      </v-flex>-->
<!--      <v-flex class="text-xl-left"><v-btn depressed large color="primary ex-lg-btn ml-3" @click="goToCalendar"><span class="m-icn icn-calendar"></span>Zobrazit kalendář akcí</v-btn></v-flex>-->
<!--      <v-flex sm12 lg12 class="text-xl-left">-->
        <v-btn style="height: auto; padding: 15px" depressed large color="button-twoline primary ex-lg-btn ml" @click="goToFastSelect(false)"><span class="m-icn icn-calendar"></span><span><span>Rychlý výběr akce</span><span>Sjezd řeky</span></span></v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout  v-if="this.getStore()==24" >
      <h1 style="display: block; color: white; text-align: center; width: 100%;">Veškeré objednávky v Hradci Králové na telefonním čísle: <a href="tel:+420 603 143 199">+420 603 143 199</a></h1>
    </v-layout>
    <v-layout mt-5 mb-5 fill-height align-start align-baseline align-center justify-center>
      <div class="uppercase display-1 white--text" color="white">Nadcházející akce</div>
    </v-layout>
    <v-layout row-minus-margin row wrap fill-height align-start align-baseline align-center justify-center>
      <!--<v-flex xl12 align class="text-xl-right"></v-flex>-->
      <v-flex fill-height xs12 sm6 lg4 xl3 :key="nid"
              v-for="({title, popis, url, kapacita, volna_mista, nid, field_akce_datum_od_do_value, field_akce_datum_od_do_value2, cena_za_prkno}) in sluzby"
              v-match-heights="{el: ['.rezervation-item']}">
        <v-card class="ma-3 pa-0 pb-3 rezervation-item" flat tile>
          <img class="img-responsive" :src="url"/>
          <v-card-title>
            <div class="media-content">
              <h3 class="headline mb-1" v-text="title"></h3>
              <div class="card-content" v-html="popis"></div>
            </div>
          </v-card-title>
          <div class="px-3">
            <v-layout row wrap fill-height align-center justify-space-between>
              <v-flex fill-height xs12 xl4 lg4>
                <p class="card-botom-content-item">
                  <v-icon light color="black" class="base-icn">fas fa-user</v-icon>
                  <span :class="['akce-kapacita__field', 'akce-kapacita__field--volna', volna_mista == 0 ? 'action-is-sold' : '']" v-text="volna_mista != 0 ? volna_mista + ' ' + freePlacesLabelFormated : 'vyprodáno'"></span>
                  <!--<span class="akce-kapacita__field akce-kapacita__field&#45;&#45;slash">/</span>-->
                  <!--<span class="akce-kapacita__field akce-kapacita__field&#45;&#45;plna">{{kapacita}}</span>-->
                </p>
              </v-flex>
              <v-flex fill-height xs12 xl8 lg8>
                <p class="card-botom-content-item middle">
                  <v-icon light color="black" class="base-icn">fas fa-calendar-alt</v-icon>
                  <span class="akce-kapacita__field akce-kapacita__field--plna"
                        v-text="getDateOfAction(field_akce_datum_od_do_value)"></span>
                </p>
              </v-flex>
              <!--<v-flex fill-height xs12 xl4 lg4>-->
                <!--<p class="card-botom-content-item last">-->
                  <!--<v-icon light color="black" class="base-icn">fas fa-coins</v-icon>-->
                  <!--<span class="akce-kapacita__field akce-kapacita__field&#45;&#45;plna">od {{ cena_za_prkno }} Kč</span>-->
                <!--</p>-->
              <!--</v-flex>-->
            </v-layout>
            <v-layout align-center justify-center class="mt-3">
              <v-btn :disabled="volna_mista == 0" class="my-0" depressed large color="primary" @click="selectService(nid)">Zarezervovat</v-btn>
            </v-layout>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="pageCount > 1" mt-5 mb-5 fill-height align-start align-baseline align-center justify-center>
      <v-pagination :length="pageCount" v-model="page"></v-pagination>
    </v-layout>
  </div>
</template>

<script>
  import Footer from '@/components/Footer'
  import moment from 'moment-timezone'
  import {init} from '@/api/api'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      Footer
    },
    data() {
      return {
        page: 1,
        pageCount: 1,
      }
    },
    computed: {
      ...mapGetters([
        'selectedService',
        'getMainServiceID',
      ]),
      sluzby() {
        return this.$store.state.services.filter(item => item.nid != 4 && item.nid != 281  && item.nid != 1982)
      },
      freePlacesLabelFormated() {
        return this.volna_mista == 1 ? 'volné' : this.volna_mista < 5 ? 'volná' : 'volných';
      }
    },
    methods: {
      getMainID() {
        return this.getMainServiceID.nid;
      },
      goToCalendar() {
        this.$router.push({name: 'Calendar'});
      },
        goToFastSelect(selectLode) {
        this.$store.commit('setSelectLode', selectLode);
        this.$router.push({name: 'FastSelect1'});
      },
      selectService(id) {
        console.log(id);
        this.$store.dispatch('setService', id).then(() => {
          this.$router.push({ name: 'Step2', params: { actionID: id, prevRoute: 'Step1' }});
        })
      },
      getDateOfAction(date) {
        var d = moment.utc(date).tz('Europe/Prague');

        return d.format('DD. MM. YYYY') + ' od ' + d.format('HH:mm');
      },
      callInitRequest() {
        init(this.page).then(response => {
          this.$store.commit('setActionsList', response.data.data.actions);
          this.$store.commit('setPobockyOptions', response.data.data.pobocky_options);
          this.pageCount = response.data.data.page_count;
          window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        });
      },
      getStore() {
        if (window.location.hostname === 'rezervace.sup-pardubice.cz') {
          return 23;
        } else if (window.location.hostname === 'rezervace.sup-hradec.cz') {
          return 24;
        } else {
          return $cookies.isKey("STORE_COOKIE") && $cookies.get("STORE_COOKIE") === 'hk' ? 24 : 23;
        }
      }
    },
    watch: {
      page: function (val) {
        this.callInitRequest();
      },
    },
    mounted() {
      this.$store.commit('resetServices');
      this.callInitRequest();
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Step1.vue